<template>
  <div>
    <el-dialog
      title="新增员工"
      :visible.sync="showFlag"
      width="30%"
      center
      :close-on-click-modal="false"
      :before-close="closeModal"
    >
      <div class="Form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="员工姓名" prop="companyUserName">
            <el-input
              v-model="ruleForm.companyUserName"
              class="product_input"
              maxlength="20"
              placeholder="请输入员工姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              class="product_input"
              placeholder="请输入手机号"
              maxLength="11"
            ></el-input>
          </el-form-item>
          <el-form-item label="员工角色" prop="role">
            <el-select
              filterable
              v-model="ruleForm.role"
              placeholder="请选择员工角色"
            >
              <el-option
                v-for="item in staffList"
                :label="item.roleName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="submit_wrap">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >保 存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { REG_TEL } from "@/utils/index";
import { getStorage } from "@/utils/storage";
import { getListByMissionCharge, addByMission } from "@/api/request/snkd.user";
export default {
  props: {
    showFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      companyId: "",
      farmId: "",
      dialogImageUrl: "",
      dialogVisible: false,
      //员工角色列表
      staffList: [],
      ruleForm: {
        companyUserName: "",
        phone: "",
        role: "",
      },
      rules: {
        companyUserName: [
          { required: true, message: "请输入员工姓名", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: REG_TEL,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        role: [
          { required: true, message: "请选择员工角色", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    this.getStaffList();
  },
  methods: {
    async getStaffList() {
      await getListByMissionCharge({
        companyId: this.companyId,
      }).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.staffList = obj.list || [];
        }
      });
    },
    async saveForm() {
      let params = {
        ...this.ruleForm,
        companyId: this.companyId,
        farmId: this.farmId,
        roleIdList: [this.ruleForm.role],
      };
      await addByMission(params).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.$emit("update:showFlag", false);
          this.$emit("updateMissionList");
          this.$emit("updateMissionId", obj.userId);
          this.resetForm();
        }
      });
    },
    //关闭弹窗
    closeModal() {
      this.$emit("update:showFlag", false);
      this.resetForm();
    },
    //重置表单
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    //表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          this.saveForm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.submit_wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    margin-top: 20px;
    width: 110px;
  }
}
.el-select {
  width: 100%;
}
</style>
